import BaseService from "@/attributes/BaseService";
class _PageService extends BaseService {}

export default _PageService;
